var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-overlay',{staticClass:"modal-root",attrs:{"isOpen":!!_vm.currentComponent,"popup-alignment":_vm.popupAlignment}},[_c(_vm.currentComponent,_vm._b({tag:"component",on:{"close":_vm.handleClose}},'component',_vm.props,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }